import EmailCampaign from './container/campaignList';
import EditCampaign from './container/edtCampaign';
import NewCampaign from './container/newCampaign';

export {
    EmailCampaign,
    EditCampaign,
    NewCampaign
};





// WEBPACK FOOTER //
// ./src/views/email/emailCampaign/index.js